// src/services/axiosClient.js or axiosClient.ts
import axios from "axios";


const auth_axios_client = axios.create({
  baseURL: `${process.env.REACT_APP_EDUCATION_VIDEO_BASE_URL}/api/`,
  withCredentials: true,
  withXSRFToken: true,
   headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      }
});





export default auth_axios_client;
